import store from '~/store'

export default (to, from, next) => {
    if (store.getters['auth/user'].role !== 'admin' && store.getters['auth/user'].role !== 'rep') {
        next({ name: 'home' })
    } else {
        next()
    }
}
